import * as React from 'react';
import './Spinner.css'; // Import the CSS file

interface SpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  overlay?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({
                                           message = "Loading...",
                                           size = 'md',
                                           overlay = true
                                         }) => {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-16 w-16',
    lg: 'h-24 w-24'
  };

  const flexSpinStyle: React.CSSProperties = {
    '--duration': '2s'  // or whatever duration you want
  } as React.CSSProperties;

  const spinnerContent = (
    <div className="flex flex-col items-center">
      {message && (
        <p className="mb-3 text-sm font-medium text-gray-700 text-center">
          {message}
        </p>
      )}

      <svg className={`spinner-container ${sizeClasses[size]}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />

        <g className="spinner-path-flex origin-center" style={flexSpinStyle}>
          <circle
            cx="12"
            cy="12"
            r="10"
          />
        </g>
      </svg>

      <span className="sr-only">{message}</span>
    </div>
  );

  if (overlay) {
    return (
      <div
        className="absolute inset-0 z-10 flex flex-col items-center justify-center rounded-md bg-gray-200 bg-opacity-60"
        role="status"
        aria-live="polite"
        aria-label={message}
      >
        {spinnerContent}
      </div>
    );
  }

  return (
    <div
      className="flex items-center justify-center"
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      {spinnerContent}
    </div>
  );
};

export default Spinner;